import { Typography, useThemeProvider } from "@albo-ui/core";
import { Box } from "@mui/material";
import { useCRMDeals } from "./hooks/useCRMDeals";
import CustomPagination from "../../elements/CustomPagination";
import { ColumnBoard } from "../../elements";

export const CRMDeals = ({ changeAlert, sectionData, columns, getData, getRevenue, form, tabActive, getLeadByUuid, ctFunnel, revenueData, pagination }: any) => {
    const { theme } = useThemeProvider();
    const { onChangeStatus } = useCRMDeals(changeAlert, form, getData, getRevenue);

    let draggedCard: Omit<any, "removeClick" | "dragAction">;
    const setDragged = (card: Omit<any, "removeClick" | "dragAction">) => {
        draggedCard = card;
    };

    const cardDropped = (listIndex: number) => {
        if (draggedCard && draggedCard["low_funnel"] !== columns[listIndex]["key"]) {
            onChangeStatus(tabActive, draggedCard, columns[listIndex]["key"]);
        }
    };

    const revenueSection = (key) => {
        let item = { nMAB: 0, nMAW: 0, nMAD: 0 };

        if(typeof key === "string"){
            let getLowFunnel = revenueData["funnelData"]?.filter((r) => r["_id"] === key);
            if (getLowFunnel?.length > 0) {
                item = getLowFunnel[0];
            }
        }
        if(typeof key === "object"){
            item = key;
        }

        const formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
        });

        return (
            <Box display={"grid"}>
                <Typography variant="smallTitle" style={{ fontSize: 14, paddingBottom: 2 }}>
                    {formatter.format((item && (item["nMAB"] || 0) + (item["nMAW"] || 0) + (item["nMAD"] || 0)) || 0)}
                </Typography>
                <Typography variant="paragraph" color="darkGray" style={{ fontSize: 10, lineHeight: 1.3 }}>
                    nMAB {formatter.format((item && item["nMAB"]) || 0)}
                </Typography>
                <Typography variant="paragraph" color="darkGray" style={{ fontSize: 10, lineHeight: 1.3 }}>
                    nMAW {formatter.format((item && item["nMAW"]) || 0)}
                </Typography>
                <Typography variant="paragraph" color="darkGray" style={{ fontSize: 10, lineHeight: 1.3 }}>
                    nMAD {formatter.format((item && item["nMAD"]) || 0)}
                </Typography>
            </Box>
        );
    };

    // ----------------------------------------------------
    const countDealsByFunnel = (key) => {
        let c = revenueData["funnelData"]?.filter((item) => key === item["_id"]);
        if(c?.length > 0){
            return c[0]["count"];
        } else {
            return 0;
        }
    };

    function percentage(percent, total) {
        return Math.round(total > 0 ? (percent / total) * 100 : 0);
    }

    return (
        <>
            <Box style={{ display: "flex", maxHeight: 550, overflowX: "scroll", marginTop: 1, borderColor: theme.colors.manatee}}>
                <Box style={{ display: "flex", flexWrap: "nowrap" }}>
                    {columns.map(({ key, label }, listIndex) => {
                        let count = countDealsByFunnel(key);

                        return (
                            <ColumnBoard
                                key={key}
                                funnelKey={key}
                                listIndex={listIndex}
                                sectionData={sectionData}
                                count={count}
                                property={"low_funnel"}
                                setDragged={setDragged}
                                cardDropped={cardDropped}
                                cardProps={{ ctFunnel, getLeadByUuid, revenueSection, tabActive }}
                                cardType={"CRMCardDeals"}
                            >
                                <Box display={"grid"}>
                                    <Box display={"flex"} justifyContent={"space-between"}>
                                        <Typography variant="paragraph" style={{fontSize: 14, color: "#000000", marginRight: 5}}>{label}</Typography>
                                        <Box display={"flex"} height={"fit-content"}>
                                            <Box sx={{ px: 0.8, py: 0.5, mr: 0.8, borderRadius: 2, backgroundColor: "thistle", fontWeight: "bold", fontSize: 12}}>
                                                {count}
                                            </Box>
                                            <Box sx={{ px: 0.8, py: 0.5, borderRadius: 2, backgroundColor: "#bfd8c5", fontWeight: "bold", fontSize: 12}}>
                                                {percentage(count, revenueData["totalCount"])}%
                                            </Box>
                                        </Box>
                                    </Box>

                                    {revenueSection(key)}
                                </Box>
                            </ColumnBoard>
                        );
                    })}
                </Box>
            </Box>
            {sectionData?.length > 0 && (
                <CustomPagination
                    page={pagination.page - 1}
                    rows={pagination.totalDocuments}
                    rowsPerPage={pagination.rowsPerPage}
                    handleChangePage={pagination.onChangePage}
                    handleChangeRowsPerPage={pagination.onChangeRowsPerPage}
                />
            )}
        </>
    );
};
